import ServicePage from './page';
import { financialPlanningData } from '@/mocks/servicePagesBatch2';

export default function FinancialPlanningPage() {
  return <ServicePage data={financialPlanningData} />;
}